import { useOrganizationDetails } from '../../../../hooks/useOrganizationDetails';
import useOrganization from '../../../../OrganizationContext';
import { LICENSE_EXPIRATION_STATUS } from '../consts';
import { getLicenseStatus, isLicensesEnabled } from '../utils';

const isLicenseValidForLossLocation = (license, lossLocationState) => {
  return (
    license.state === lossLocationState &&
    getLicenseStatus(license.expiration_date) !== LICENSE_EXPIRATION_STATUS.EXPIRED
  );
};

/**
 *
 * @returns {{isLicensesEnabled: *, isLicenseCorrelationEnabled: *, isAdjusterLicensedForLossLocation: ((function(*, *): (boolean|*))|*)}}
 */
export const useLicenses = () => {
  const { organization } = useOrganizationDetails({ kind: 'sysconfig_with_client_fallback' });
  const { isLicenseCorrelationEnabled, isLicensePresentationEnabled } = useOrganization();

  const isLicensesFeatureEnabled = isLicensesEnabled(organization);
  const isCorrelationEnabled = isLicensesFeatureEnabled && isLicenseCorrelationEnabled;
  const isPresentationEnabled = isLicensesFeatureEnabled && isLicensePresentationEnabled;

  const isAdjusterLicensedForLossLocation = (adjuster, lossLocationState) => {
    if (!lossLocationState) {
      return false;
    }

    if (!(isLicensesFeatureEnabled && (isLicenseCorrelationEnabled || isLicensePresentationEnabled))) {
      return true;
    }

    return adjuster?.licenses?.some((license) => isLicenseValidForLossLocation(license, lossLocationState));
  };

  return {
    isLicensesFeatureEnabled,
    isLicenseCorrelationEnabled: isCorrelationEnabled,
    isLicensePresentationEnabled: isPresentationEnabled,
    isAdjusterLicensedForLossLocation,
  };
};
